<template>
	<el-row class="points-show">
		<el-col :span="24">
			<el-col :span="10">角色权限</el-col>
			<el-col :span="4" :offset="10">
				<el-button type="primary" size="mini" style="margin-left: 30px" @click="addRoles(1)" plain>
					添加角色<i class="el-icon-add"></i>
				</el-button>
			</el-col>
		</el-col>
		<el-divider></el-divider>
		<el-col :span="24">
			<el-table :data="RoleList" :height="tableHeight" style="width: 100%">
				<el-table-column width="180" prop="id" label="角色id">
				</el-table-column>
				<el-table-column prop="roleName" label="角色名称"> </el-table-column>
				<el-table-column label="角色状态">
					<template slot-scope="scope">
						<el-switch style="display: block" v-model="scope.row.status == 0" active-color="#13ce66"
							inactive-color="#ff4949" active-text="启用" inactive-text="禁用"
							@change="cantShow(scope.row.roleName, scope.row.id, scope.row.status)">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column width="280" label="创建时间">
					<template slot-scope="scope">
						<span>{{ scope.row.createTime | formatDate }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" @click="Assignment(scope.row)">
							权限管理
						</el-button>

						<el-button size="mini" @click="addRoles(2,scope.row)">
							编辑
						</el-button>
						<el-button size="mini" type="danger" @click="delRole(scope.row.id)">
							移除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 添加/编辑弹框 -->
		<el-col>
			<el-dialog :title="editStatus == 1 ? '添加角色' : '编辑角色'" :visible.sync="dialogVisible"
				:before-close="closeUpdate" width="30%">
				<!-- 新增用户-->
				<template v-if="editStatus == 1">
					<el-form :model="addAuthform" label-position="right" label-width="120px">
						<el-form-item label="角色名称:">
							<el-input size="mini" :rows="5" placeholder="请输入角色名称" v-model="addAuthform.roleName">
							</el-input>
						</el-form-item>
						<el-form-item label="角色状态:">
							<el-radio-group v-model="addAuthform.status">
								<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
									{{ item.title }}
								</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-form>
				</template>

				<!-- 修改用户-->
				<template v-if="editStatus == 2">
					<el-form :model="editAuthform" label-position="right" label-width="120px">
						<el-form-item label="用户名称:">
							<el-input size="mini" :rows="5" placeholder="请输入角色名称" v-model="editAuthform.roleName">
							</el-input>
						</el-form-item>
						<el-form-item label="角色状态:">
							<el-radio-group v-model="editAuthform.status">
								<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
									{{ item.title }}
								</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-form>
				</template>

				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click="closeUpdate">取 消</el-button>
					<el-button size="mini" type="primary" @click="determine()">确 定</el-button>
				</div>
			</el-dialog>
			<!-- 权限管理 -->
			<el-dialog title="角色分配" :visible.sync="dialogAuthVisible" :before-close="closeUpdate" width="40%">
				<!-- 角色分配-->
				<el-form :model="editRoleform" label-position="right" label-width="120px">
					<el-form-item label="角色名称:">
						<el-input size="mini" :rows="5" disabled placeholder="请输入用户名称" v-model="editRoleform.roleName">
						</el-input>
					</el-form-item>
					<el-form-item label="角色权限:">
						<div class="scroll-view">
							<el-tree ref="menuTree" :data="authList" show-checkbox node-key="id"
								:default-checked-keys="defaultSelectAuth" :props="defaultProps"
								@check-change="handleCheckChange">
							</el-tree>
						</div>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click="closeUpdate">取 消</el-button>
					<el-button size="mini" type="primary" @click="determineRole()">确 定</el-button>
				</div>
			</el-dialog>
		</el-col>
	</el-row>
</template>

<script>
	var vm;
	export default {
		data() {
			return {
				tableHeight: window.innerHeight - 200,
				RoleList: [],
				editStatus: -1,
				dialogVisible: false,
				dialogAuthVisible: false,
				defaultSelectAuth: [],
				authList: [],
				defaultProps: {
					children: 'children',
					label: 'authName'
				},
				addAuthform: {
					roleName: '',
					status: -1
				},
				editAuthform: {
					id: '',
					roleName: '',
					status: -1
				},
				editRoleform: {
					id: '',
					roleName: '',
					SelectAuth: []
				},

				reviewStatus: [{
						title: "启用",
						type: 0,
					},
					{
						title: "禁用",
						type: 1,
					},
				]
			};
		},
		created() {
			vm = this;
			this.getRoleList();
		},
		filters: {
			// 使用计算属性
			formatDate(val) {
				return val ? vm.$moment(val).format("YYYY-MM-DD HH:MM:SS") : "";
			},
		},
		methods: {
			//获取角色列表
			getRoleList() {
				this.$http
					.post(`/api/source/sysRole/select`, {
						deleteStatus: 0,
					})
					.then((res) => {
						if (res.data.status == 0) {
							// console.log(res.data.data, "角色列表");
							this.RoleList = res.data.data;
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
			//添加角色
			addRoles(type, val) {
				;
				this.editStatus = type
				if (type == 2) {
					this.editAuthform.id = val.id
					this.editAuthform.roleName = val.roleName
					this.editAuthform.status = val.status
				}
				this.dialogVisible = true
			},

			cantShow(roleName, id, status) {
				status = status == 0 ? 1 : 0;
				this.$http
					.get(`/api/source/sysRole/upodateStatus/${id}/${status}`, {})
					.then((res) => {
						if (res.data.status == 0) {
							var statusText = status != 0 ? "禁用" : "启用";
							if (status != 0) {
								this.$message.error(roleName + "已" + statusText);
							} else {
								this.$message.success(roleName + "已" + statusText);
							}
							this.getRoleList();
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
			},
			//隐藏弹框
			closeUpdate() {
				this.addAuthform = {
						roleName: '',
						status: -1
					},
					this.editAuthform = {
						id: '',
						roleName: '',
						status: -1
					},
					this.editStatus = -1,
					this.editRoleform = {
						id: '',
						userName: '',
						roleList: []
					},
					this.dialogAuthVisible = false
				this.dialogVisible = false
			},
			//角色权限分配
			Assignment(roleInfo) {
				var _this = this
				this.editRoleform.id = roleInfo.id
				this.editRoleform.roleName = roleInfo.roleName
				var data = {
					status: 0,
					deleteStatus: 0,
					roleId: roleInfo.id,
				};
				this.$http.post(`/api/source/sysAuth/selectayuan`, data).then((res) => {
					if (res.data.status == 0) {
						// console.log(res.data.data, "角色权限分配");
						var list = res.data.data;
						var arr = [];
						var arrlist = [];
						var defaultSelect = [];
						var defaultSelectList = [];
						list.forEach((item) => {
							arrlist.push(item);
							if (!!item.sysAuths) {
								item.children = item.sysAuths;
								arr = this._.concat(arr, item.sysAuths);
								arrlist = this._.concat(arrlist, item.sysAuths);
							} else {
								arr.push(item);
							}
						});
						arr.forEach((val) => {
							if (val.checked) {
								defaultSelect.push(val.id);
							}
						});
						arrlist.forEach((i) => {
							if (i.checked) {
								defaultSelectList.push(i.id);
							}
						});
						_this.defaultSelectAuth = defaultSelect //展示状态
						_this.editRoleform.SelectAuth = defaultSelectList //提交状态
						_this.authList = list
						_this.dialogAuthVisible = true
					} else {
						this.$message.error("发生未可知错误，请联系开发人员");
					}
				});
			},
			//角色分配 确定
			determineRole() {
				var data = []
				this.editRoleform.SelectAuth.forEach(item => {
					data.push({
						authId: item
					})
				})

				this.$http
					.post(`/api/source/sysRole/settingAuth/${this.editRoleform.id}`, data)
					.then(res => {
						if (res.data.status == 0) {
							this.$message.success("数据更新成功！！");

						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
						this.closeUpdate() //关闭弹窗
					})
			},
			//新增/编辑角色
			determine() {
				let _this = this;
				//添加
				if (this.editStatus == 1) {
					if (
						!this.addAuthform.roleName.trim() ||
						this.addAuthform.status < 0
					) {
						return this.$message({
							type: "error",
							message: "请填写完整角色信息再提交~~",
						});
					}
					var data = {
						...this.addAuthform,
						deleteStatus: 0
					};

					this.$http
						.post(`/api/source/sysRole/insert`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "添加角色成功！！",
								});
								_this.getRoleList();
								_this.closeUpdate();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
				//修改
				if (this.editStatus == 2) {
					var data = {
						...this.editAuthform
					};

					this.$http
						.post(`/api/source/sysRole/update`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "修改角色信息成功！！",
								});
								_this.getRoleList();
								_this.closeUpdate();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
			},
			//权限分配 tree 变化
			handleCheckChange(data, checked, indeterminate) {
				this.editRoleform.SelectAuth = this._.concat(this.$refs.menuTree.getCheckedKeys(), this.$refs.menuTree
					.getHalfCheckedKeys());
			},
			//删除角色
			delRole(id) {
				this.$confirm('此操作将删除该角色, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.get(`/api/source/sysRole/deleteById/${id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getRoleList()
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			},




























		},
	};
</script>

<style scoped lang="less">
	.scroll-view {
		max-height: 260px;
		overflow-y: scroll;
		overflow-x: hidden;
		margin: 10px 30px;
	}

	.scroll-view::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 4px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	.scroll-view::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 2px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #66b8ff;
	}

	.scroll-view::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 2px;
		background: #ededed;
	}
</style>
